import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AppRoutes from "../../helper/app-routes";
import Navbar from "../NoteneticNavbar/index";

const CustomDrawer = () => {
  const location = useLocation();

  const customSidebarMenu = [
    {
      name: "Dashboard",
      icon: "fa-th-large",
      route: AppRoutes.DASHBOARD,
    },
    {
      name: "Users",
      icon: "fa-users",
      subMenu: [
        {
          icon: "fa-user-shield",
          name: "Admin User",
          route: AppRoutes.ADMIN_USER,
        },
        { icon: "fa-search", name: "Staff", route: AppRoutes.STAFF_SEARCH },
        { icon: "fa-search", name: "Client", route: AppRoutes.CLIENT_SEARCH },
      ],
    },
    {
      name: "Clinic",
      icon: "fa-hospital-user",
      subMenu: [
        { icon: "fa-hospital", name: "All Clinic", route: AppRoutes.CLINIC },
        {
          icon: "fa-file-contract",
          name: "Copy Services",
          route: AppRoutes.COPY_SERVICES,
        },
      ],
    },
    {
      name: "Templates",
      icon: "fa-file-contract",
      subMenu: [
        {
          icon: "fa-file",
          name: "Document Templates",
          route: AppRoutes.FILE_DOCUMENT_TEMPLATE,
        },
        {
          icon: "fa-file-import",
          name: "Document Templates Uploader",
          route: AppRoutes.DOCUMENT_TRANS_COMPILER,
        },
        {
          icon: "fa-tag",
          name: "Document Label",
          route: AppRoutes.DOCUMENT_TEMPLATE_LABEL_LIST,
        },
        {
          icon: "fa-file-lines",
          name: "Staff Template",
          route: AppRoutes.STAFF_DOCUMENT_TEMPLATE,
        },
         {
          icon: "fa-file-import",
             name: "AI Document Template Manager",
          route: AppRoutes.AI_DOCUMENT_TEMPLATE,
        },
      ],
    },
    {
      name: "Imports",
      icon: "fa-cloud-arrow-up",
      subMenu: [
        { icon: "fa-code", name: "Dx import", route: AppRoutes.FILE_UPLOAD },
        {
          icon: "fa-file-import",
          name: "Clinic Import",
          route: AppRoutes.DATA_IMPORT,
        },
        {
          icon: "fa-file-import",
          name: "EOB 835 Import",
          route: AppRoutes.EOB_IMPORT,
        },
      ],
    },
    {
      name: "Misc",
      icon: "fa-circle-exclamation",
      subMenu: [
        {
          icon: "fa-users-rectangle",
          name: "Training Links",
          route: AppRoutes.TRAINING_LINKS,
        },
        {
          icon: "fa-bullhorn",
          name: "Announcement",
          route: AppRoutes.ANNOUNCEMENT,
        },
        {
          icon: "fa-bullhorn",
          name: "BAA",
          route: AppRoutes.BAA,
        },
        { icon: "fa-file-import", name: "Logs", route: AppRoutes.LOGS },
        {
          icon: "fa-user-secret",
          name: "Role Settings",
          route: AppRoutes.ACCESS_LEVEL_SETTINGS,
        },
        {
          icon: "fa-file-shield",
          name: "Subpoena Request",
          route: AppRoutes.SUBPOENA_REQUEST,
        },
        {
          icon: "fa-comment",
          name: "SMS / Twilio Lookup",
          route: AppRoutes.SMS_TWILIO_LOOKUP,
        },
      ],
    },
  ];

  const toggleMenu = (index) => {
    setOpenMenus((prev) => {
      const newSet = new Set(prev);
      newSet.has(index) ? newSet.delete(index) : newSet.add(index);
      return newSet;
    });
  };
  const [openMenus, setOpenMenus] = useState(() => {
    const allOpen = new Set();
    customSidebarMenu.forEach((item, index) => {
      if (item.subMenu) {
        allOpen.add(index);
      }
    });
    return allOpen;
  });
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <Navbar>
      <ul className="drop-down-list list-unstyled mb-0">
        {customSidebarMenu.map((item, index) => {
          const hasSubMenu = !!item.subMenu;
          const isOpen = openMenus.has(index);

          return (
            <li
              key={index}
              className={`sidebar_list position-relative d-flex align-items-start flex-column w-100 ${
                !hasSubMenu ? "NoSubmenu" : ""
              }`}
            >
              {hasSubMenu ? (
                <>
                  <div
                    className="dropdown-toggle toggle_cus d-flex align-items-center w-100"
                    onClick={() => toggleMenu(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title={item.name}
                      className="collapsIcon"
                    >
                      <i className={`fa ${item.icon} mr-1`} />
                    </span>
                    <span className="flex-grow-1">{item.name}</span>
                    <i
                      className={`fa fa-chevron-${
                        isOpen ? "up" : "down"
                      } ml-auto f-12`}
                    />
                  </div>
                  <div
                    className={`dropdown-menu ${isOpen ? "show" : ""} w-100`}
                  >
                    <ul className="list-unstyled mb-0">
                      {item.subMenu.map((sub, i) => (
                        <li
                          key={i}
                          className={
                            location.pathname === sub.route ? "active" : ""
                          }
                        >
                          <Link
                            to={sub.route}
                            className="dropdown-item d-flex align-items-center"
                          >
                            <span
                              data-bs-toggle="tooltip"
                              data-bs-placement="right"
                              title={sub.name}
                              className="collapsIcon"
                            >
                              <i className={`fa ${sub.icon} mr-1`} />
                            </span>
                            <span>{sub.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <Link
                  to={item.route}
                  className="text-decoration-none d-flex align-items-center"
                >
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title={item.name}
                    className="collapsIcon"
                  >
                    <i className={`fa ${item.icon} mr-1`} />
                  </span>
                  <span>{item.name}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </Navbar>
  );
};

export default CustomDrawer;
